import { CommonImages } from "../../../../reusableUI/images";
import { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import DatePicker from "react-date-picker";
import { FaRegCalendarAlt } from "react-icons/fa";
import { paymentRefund, visitPayout } from "../../../../Service/serviceVisits";
import moment from "moment";
import { showToast } from "../../../../reusableUI/toaster";
import Loader from "../../../../reusableUI/loader";

const PaymentIssue = ({ isOpen, visit, onClose }) => {
  const [selectedUserType, setSelectedUserType] = useState("");
  const [loading, setLoading] = useState();
  const [toastMsg, setToastMsg] = useState(null);
  const initialTabState = {
    selectedOption1: "",
    selectedOption2: "",
    fromDate: null,
    toDate: null,
    partialAmount: "",
  };
  const [tabState, setTabState] = useState({
    tab1: { ...initialTabState },
    tab2: { ...initialTabState },
  });

  const visitStartDate = visit?.visitInfo?.startDate;
  const visitEndDate = visit?.visitInfo?.endDate;

  const handleRadioChange = (tab, group, value) => {
    setTabState((prev) => ({
      ...prev,
      [tab]: {
        ...prev[tab],
        [group]: value,
      },
    }));
  };

  const handlePartialAmountChange = (tab, value) => {
    setTabState((prev) => ({
      ...prev,
      [tab]: {
        ...prev[tab],
        partialAmount: value,
      },
    }));
  };

  const handleSave = async (type, tabKey) => {
    const confirmed = window.confirm("Are you sure you want to save this?");
    if (!confirmed) return;

    const currentTabData = tabState[tabKey];

    console.log(tabKey);

    const data = {
      visitID: visit._id,
      refundType: currentTabData.selectedOption1,
      ...(tabKey === "tab1" && { role: selectedUserType }),
      amount:
        currentTabData.selectedOption1 === "partial"
          ? currentTabData.partialAmount
          : 0,
      dateType: currentTabData.selectedOption2,
      fromDate: moment(currentTabData.fromDate).format("YYYY-MM-DD"),
      toDate: moment(currentTabData.toDate).format("YYYY-MM-DD"),
      userID:
        selectedUserType === "nurse"
          ? visit.specialistInfo.userID
          : visit.patient.userID,
    };

    console.log(data);
    if (tabKey === "tab1") {
      setLoading(true);
      try {
        const req = await paymentRefund(data);
        if (req.error === false) {
          showToast("Refund processed successfully", "Success");
          setTimeout(() => {
            onClose();
          }, 1000);
        } else {
          showToast("Failed to process refund", "Error");
        }
      } catch (err) {
        showToast("Something went wrong. Please try again.", "Error");
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        const req = await visitPayout(data);
        if (req.error === false) {
          showToast("Payout issued successfully", "Success");
          setTimeout(() => {
            onClose();
          }, 1000);
        } else {
          showToast("Failed to issue payout", "Error");
        }
      } catch (err) {
        showToast("Something went wrong. Please try again.", "Error");
      } finally {
        setLoading(false);
      }
    }
  };

  const renderTabPanel = (tabKey) => {
    const {
      selectedOption1,
      selectedOption2,
      fromDate,
      toDate,
      partialAmount,
    } = tabState[tabKey];

    const topMarginClass = tabKey === "tab1" ? "mt-2" : "";

    return (
      <TabPanel className="flex flex-col justify-center pb-6">
        {tabKey === "tab1" && (
          <div className="items-center mx-auto gap-4 mt-4">
            <p className="text-[13px] font-semibold mb-2">Role</p>
            <div className="flex items-center mx-auto gap-4 mt-2 mb-2">
              <select
                value={selectedUserType}
                onChange={(e) => setSelectedUserType(e.target.value)}
                className="border border-blue-600 rounded-md w-[250px] py-1.5 px-2 text-[12px] focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" hidden>
                  Select User Type
                </option>
                <option value="patient">Patient</option>
                <option value="nurse">Nurse</option>
              </select>
            </div>
          </div>
        )}

        <div className={`mb-2 pl-4 ${topMarginClass}`}>
          <p className="text-[13px] font-semibold mb-2">Payment Type</p>
          <select
            value={selectedOption1}
            onChange={(e) =>
              handleRadioChange(tabKey, "selectedOption1", e.target.value)
            }
            className="border border-blue-600 rounded-md px-2 py-1.5 text-[12px] w-[250px] focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="" hidden>
              Select Payment Type
            </option>
            <option value="full">Full</option>
            <option value="partial">Partial</option>
          </select>
        </div>

        {selectedOption1 === "partial" && (
          <div className="flex flex-col justify-center items-center ml-1">
            <input
              type="number"
              className="p-2 pl-1.5 border border-1 py-1.5 w-[250px] border-blue-600 rounded-md text-[12px]"
              placeholder="Enter Amount"
              value={partialAmount}
              onChange={(e) =>
                handlePartialAmountChange(tabKey, e.target.value)
              }
            />
            <div className="border-b-[1px] border-gray-200 w-full mt-6 mb-4"></div>
          </div>
        )}

        <div className={`mb-2 pl-4 ${topMarginClass}`}>
          <p className="text-[13px] font-semibold mb-2">Service Period</p>
          <select
            value={selectedOption2}
            onChange={(e) =>
              handleRadioChange(tabKey, "selectedOption2", e.target.value)
            }
            className="border border-blue-600 rounded-md px-2 py-1.5 text-[12px] w-[250px] focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="" hidden>
              Select
            </option>
            <option value="single">Single</option>
            <option value="range">Range</option>
          </select>
        </div>

        <div className="flex flex-col items-center mt-2">
          <div className="flex flex-row justify-center items-center gap-2">
            {(selectedOption1 === "single" ||
              selectedOption2 === "single" ||
              selectedOption1 === "range" ||
              selectedOption2 === "range") && (
              <div>
                <p className="text-[13px] font-semibold mb-2">
                  {selectedOption2 === "single" ? "Date" : "From Date"}
                </p>

                <DatePicker
                  value={fromDate}
                  onChange={(date) =>
                    handleRadioChange(tabKey, "fromDate", date)
                  }
                  className="w-full text-[12px]"
                  placeholderText="Select a date"
                  dateFormat="dd/MM/yyyy"
                  clearIcon={null}
                  calendarIcon={<FaRegCalendarAlt color="blue" size={16} />}
                  minDate={new Date(visitStartDate)}
                  maxDate={new Date(visitEndDate)}
                />
              </div>
            )}

            {selectedOption1 === "range" ||
              (selectedOption2 === "range" && (
                <div>
                  <p className="text-[13px] font-semibold mb-2">To Date</p>

                  <DatePicker
                    value={toDate}
                    onChange={(date) =>
                      handleRadioChange(tabKey, "toDate", date)
                    }
                    className="w-full text-[12px]"
                    placeholderText="Select a date"
                    dateFormat="dd/MM/yyyy"
                    clearIcon={null}
                    calendarIcon={<FaRegCalendarAlt color="blue" size={16} />}
                    minDate={new Date(visitStartDate)}
                    maxDate={new Date(visitEndDate)}
                  />
                </div>
              ))}
          </div>
        </div>

        <div className="flex justify-center pb-6">
          <button
            className="bg-custom-gradient text-white p-2 mt-8 text-[12px] w-24 rounded-md"
            onClick={() =>
              handleSave(
                tabKey === "tab1" ? "TriggerRefund" : "IssuePayment",
                tabKey
              )
            }
          >
            Save
          </button>

          <style jsx global>{`
            .react-date-picker__wrapper {
              border: 1px solid #3b82f6;
              border-radius: 0.375rem;
              padding: 0.25rem 0.5rem;
              transition: border-color 0.2s ease;
            }

            .react-date-picker__wrapper:focus-within {
              border-color: #2563eb;
            }

            .react-date-picker__inputGroup {
              font-size: 12px;
            }
          `}</style>
        </div>
      </TabPanel>
    );
  };

  if (!isOpen) return null;

  return (
    <div>
      {loading ? (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="flex flex-col items-center bg-white p-5 rounded-md shadow-lg w-96 h-[40vh]">
            <Loader loading={loading} />
          </div>
        </div>
      ) : (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="flex flex-col items-center bg-white p-5 rounded-md shadow-lg w-100 h-[75vh]">
            <div className="flex flex-row justify-between w-full text-md font-semibold mb-4">
              <p className="text-md text-blue-600">Payment Issue</p>
              <img
                src={CommonImages.close}
                onClick={onClose}
                className="h-6 w-6 cursor-pointer"
                alt="Close"
              />
            </div>

            <Tabs>
              <TabList className="flex space-x-6 border border-gray-300 rounded-md bg-white ">
                <Tab
                  className="py-2 px-7 cursor-pointer text-[12px] text-gray-600 rounded-md transition-all duration-300"
                  selectedClassName="bg-blue-600 text-white"
                >
                  Trigger Refund
                </Tab>
                <Tab
                  className="py-2 px-6 cursor-pointer text-[12px] text-gray-600 rounded-md transition-all duration-300"
                  selectedClassName="bg-blue-600 text-white"
                >
                  Issue pay-out
                </Tab>
              </TabList>

              {renderTabPanel("tab1")}
              {renderTabPanel("tab2")}
            </Tabs>
          </div>
        </div>
      )}
      {/* {toastMsg && <Toaster action={toastMsg.action} msg={toastMsg.msg} />} */}
    </div>
  );
};

export default PaymentIssue;
